'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var BufferList = require('bl/BufferList');

module.exports = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, b;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 2;
            _iterator = _asyncIterator(source);

          case 4:
            _context.next = 6;
            return _awaitAsyncGenerator(_iterator.next());

          case 6:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 10;
            return _awaitAsyncGenerator(_step.value);

          case 10:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 28;
              break;
            }

            b = _value;

            if (!Buffer.isBuffer(b)) {
              _context.next = 18;
              break;
            }

            _context.next = 16;
            return b;

          case 16:
            _context.next = 25;
            break;

          case 18:
            if (!BufferList.isBufferList(b)) {
              _context.next = 23;
              break;
            }

            _context.next = 21;
            return b.slice();

          case 21:
            _context.next = 25;
            break;

          case 23:
            _context.next = 25;
            return Buffer.from(b);

          case 25:
            _iteratorNormalCompletion = true;
            _context.next = 4;
            break;

          case 28:
            _context.next = 34;
            break;

          case 30:
            _context.prev = 30;
            _context.t0 = _context["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 34:
            _context.prev = 34;
            _context.prev = 35;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 39;
              break;
            }

            _context.next = 39;
            return _awaitAsyncGenerator(_iterator.return());

          case 39:
            _context.prev = 39;

            if (!_didIteratorError) {
              _context.next = 42;
              break;
            }

            throw _iteratorError;

          case 42:
            return _context.finish(39);

          case 43:
            return _context.finish(34);

          case 44:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 30, 34, 44], [35,, 39, 43]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

module.exports.toBuffer = module.exports;

module.exports.toList = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
    var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, b;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context2.prev = 2;
            _iterator2 = _asyncIterator(source);

          case 4:
            _context2.next = 6;
            return _awaitAsyncGenerator(_iterator2.next());

          case 6:
            _step2 = _context2.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context2.next = 10;
            return _awaitAsyncGenerator(_step2.value);

          case 10:
            _value2 = _context2.sent;

            if (_iteratorNormalCompletion2) {
              _context2.next = 28;
              break;
            }

            b = _value2;

            if (!Buffer.isBuffer(b)) {
              _context2.next = 18;
              break;
            }

            _context2.next = 16;
            return new BufferList().append(b);

          case 16:
            _context2.next = 25;
            break;

          case 18:
            if (!BufferList.isBufferList(b)) {
              _context2.next = 23;
              break;
            }

            _context2.next = 21;
            return b;

          case 21:
            _context2.next = 25;
            break;

          case 23:
            _context2.next = 25;
            return new BufferList().append(Buffer.from(b));

          case 25:
            _iteratorNormalCompletion2 = true;
            _context2.next = 4;
            break;

          case 28:
            _context2.next = 34;
            break;

          case 30:
            _context2.prev = 30;
            _context2.t0 = _context2["catch"](2);
            _didIteratorError2 = true;
            _iteratorError2 = _context2.t0;

          case 34:
            _context2.prev = 34;
            _context2.prev = 35;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context2.next = 39;
              break;
            }

            _context2.next = 39;
            return _awaitAsyncGenerator(_iterator2.return());

          case 39:
            _context2.prev = 39;

            if (!_didIteratorError2) {
              _context2.next = 42;
              break;
            }

            throw _iteratorError2;

          case 42:
            return _context2.finish(39);

          case 43:
            return _context2.finish(34);

          case 44:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 30, 34, 44], [35,, 39, 43]]);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}();